import axios from "axios";
// import jwt_decode from "jwt-decode";
// import dayjs from "dayjs";
// import { getAuth, setAuth } from './user';
// import { useAppDispatch, useAppSelector } from "../../../../../store/hook";
// import { refreshToken as refreshTokenUrl } from "./apiUrl";
import { getCookie, setCookie } from "./cookies";
import { store } from "../store";
import { refreshToken } from "../store/action/user";

const URL = process.env.REACT_APP_BACKEND_API;

const axiosClient = axios.create({
  baseURL: URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

const axiosClientUpload = axios.create({
  baseURL: URL,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

const axiosLogin = axios.create({
  baseURL: URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

function setAxiosClientInterceptor() {
  axiosClient.interceptors.request.use((req) => {
    // console.log("dfgdf", store.getState().user.memberId);
    let authTokens: string | null = getCookie("authToken");
    if (!authTokens) {
      return req;
    }

    // console.log("refresh", refresh)
    req.headers.Authorization = `Bearer ${authTokens}`;
    // const user: any = jwt_decode(authTokens!);
    // const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

    // if (!isExpired){
    //   return req;
    // }

    // console.log('refreshing auth token')

    return req;
  });

  axiosClient.interceptors.response.use((res)=>{
    // if (res.status != 401) {
    //   return res
    // }
    return res
  }, async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      const refreshResponse = await store.dispatch(refreshToken()).unwrap()
      if (!refreshResponse.isAuth) {
        return Promise.reject(error);
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + refreshResponse.profile?.token;
      return axiosClient(originalRequest);
    }
    return Promise.reject(error);
  })

  axiosClientUpload.interceptors.request.use((req) => {
    // console.log("dfgdf", store.getState().user.memberId);
    let authTokens: string | null = getCookie("authToken");
    if (!authTokens) {
      return req;
    }

    // console.log("refresh", refresh)
    req.headers.Authorization = `Bearer ${authTokens}`;
    // const user: any = jwt_decode(authTokens!);
    // const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

    // if (!isExpired){
    //   return req;
    // }

    // console.log('refreshing auth token')

    return req;
  });
}

// export function setAxiosClientUploadInterceptor(){
//   axiosClientUpload.interceptors.request.use(async (req: any) => {

//   //   let authTokens: any = getAuth();
//     let authTokens: any = "";

//     if (!authTokens) {
//       console.log('add token')
//       req.headers.Authorization = `Bearer ${authTokens?.authToken}`;
//     }
//     req.headers.Authorization = `Bearer ${authTokens?.authToken}`;
//     const user: any = jwt_decode(authTokens?.authToken);
//     const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;

//     if (!isExpired)
//       return req;
//     const refreshPayload = { email: authTokens.email, refreshToken: authTokens.refreshToken }
//     const response = await axiosLogin.post('users/login/refresh', JSON.stringify(refreshPayload))
//     console.log('new token')
//     console.log(response);
//   //   setAuth(response.data);
//     req.headers.Authorization = `Bearer ${response.data?.authToken}`;
//     return req;

//   })
// }

export {
  axiosClient,
  axiosLogin,
  setAxiosClientInterceptor,
  axiosClientUpload,
};
